import { LOGIC_MODES } from 'containers/QuestionnairePage/constants';

export const outcomeActionMinWidth = 138;
export const outcomeActionMaxWidth = 448;

export const outcomeActionValueMinWidth = 145;
export const outcomeActionValueMaxWidth = 340;

export const ActionKeyTypePerLogicMode = {
  [LOGIC_MODES.HIDDEN_VARIABLES]: 'type',
  [LOGIC_MODES.DISPLAY_LOGIC]: 'valueType',
};

export const actionTypeKeyGroup = 'nodeGroup';
export const actionTypeKeyResearchMethod = 'nodeResearcherMethod';

export const DATA_TEST_ID = {
  [LOGIC_MODES.HIDDEN_VARIABLES]: 'variable',
  [LOGIC_MODES.DISPLAY_LOGIC]: 'answer',
};
